module.exports = __webpack_public_path__ + "img/m6.7223282e.png";